var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: { name: "gh-card-slide" },
      on: {
        enter: _vm.onEnter,
        "after-enter": _vm.onAfterEnter,
        leave: _vm.onLeave,
        "after-leave": _vm.onAfterLeave,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expanded,
              expression: "expanded",
            },
          ],
          staticClass: "gh-card-slide__wrap",
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }